module.exports = __webpack_public_path__ + "img/20220411_130006.e153be61.jpg";